import { render } from "./page-sellfast.vue?vue&type=template&id=21cc3fc6"
import script from "./page-sellfast.js?vue&type=script&lang=js"
export * from "./page-sellfast.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__